__turbopack_context__.v({
  "badge": "RatingExplorer-module__UE9c3a__badge",
  "controls": "RatingExplorer-module__UE9c3a__controls",
  "detail": "RatingExplorer-module__UE9c3a__detail",
  "empty": "RatingExplorer-module__UE9c3a__empty",
  "header": "RatingExplorer-module__UE9c3a__header",
  "help": "RatingExplorer-module__UE9c3a__help",
  "notice": "RatingExplorer-module__UE9c3a__notice",
  "options": "RatingExplorer-module__UE9c3a__options",
  "panel": "RatingExplorer-module__UE9c3a__panel",
  "reset": "RatingExplorer-module__UE9c3a__reset",
  "root": "RatingExplorer-module__UE9c3a__root",
  "row": "RatingExplorer-module__UE9c3a__row",
  "score": "RatingExplorer-module__UE9c3a__score",
  "scroll": "RatingExplorer-module__UE9c3a__scroll",
  "table": "RatingExplorer-module__UE9c3a__table",
  "tabs": "RatingExplorer-module__UE9c3a__tabs",
  "team": "RatingExplorer-module__UE9c3a__team",
});
